<template>
    <div class="recommend-search" :data-spm="spmCode" v-if="multiData.length>0">
        <header class="title">推荐搜索</header>
        <div class="recommend-list">
            <div class="item"  v-for="(item, idx) in multiData" :key="idx" @click="handleClick(item, idx)">
                <a href="javascript:;">{{item.query}}</a>
            </div>
        </div>
    </div>
</template>
<script>
import hash from '../utils/toutiao-access.js'
    export default {
        data() {
            return {
                multiData: [],
                spm: {
                    resourceType: '',
                    mediaId: '',
                    contentId:'',
                    contentType: ''
                },
                spmCode: 'tt-search'
            }
        },
        props:{
            originalSource:{
                type: String,
                default: '20'
            }
        },
        mounted() {
            this.getHotWords()
        },
        methods: {
            handleClick(item, idx) {
                if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                    window.sohuSpm.sendAction({
                        acode: '9643',
                        clkParam: `index: ${idx + 1}`
                    });
                }
                window.location.href = item.link
            },
            getHotWords() {
                const paramData = {
                    traffic_source: 'WA1129',
                    in_tfs: 'SH',
                    original_source: this.originalSource,
                    in_ogs: this.originalSource,
                    query: window.cfgs.title || ''
                }
                const secret_key = '327dd7011df0697587c6ceb9a2283165'
                const access_key = '59d710050722fce8354455eb92bc14ba'
                const encodeQuery = encodeURIComponent(paramData.query)
                const hashData = `traffic_source=WA1129&in_tfs=SH&original_source=${this.originalSource}&in_ogs=${this.originalSource}&query=${encodeQuery}`
                const AgwAuth = hash('auth-v2', access_key, secret_key, hashData)
                if (!AgwAuth) {
                    this.multiData = []
                    return;
                }
               $.ajax({
                    type: 'GET',
                    url: '//so.toutiao.com/search/suggest/m_related_search/',
                    data: paramData,
                    headers: {
                        'Agw-Auth': AgwAuth
                    },
                    xhrFields: {
                        withCredentials: false
                    },
                    success: (res)=> {
                       if(res.data.words && res.message == 'success') {
                            if (res.data.words && res.data.words.length > 0) {
                                let multiData = res.data.words.slice(0,6)
                                for (let i = 0; i < multiData.length; i++) {
                                    multiData[i].query = multiData[i].query ? multiData[i].query.substr(0,10) : ''
                                }
                                this.multiData = multiData;
                            }
                             if (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
                                this.$nextTick(() => {
                                    window.sohuSpm.domDidChange({ target: this.spmCode });
                                })
                            }
                       }
                   },
                   error: ()=> {
                       this.multiData = []
                   }
               })
            }
        }

    }
</script>
<style lang="less">
.recommend-search {
    padding: 30px 0px 20px;
    .title {
        margin-bottom: 30px;
        font-size: 36px; /*px*/
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #111111;
        line-height: 50px; /*px*/
    }
    .recommend-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item {
            width: 302px; /*px*/
            padding: 20px 12px; /*px*/
            background: #F2F2F2;
            margin-bottom: 20px; /*px*/
            a {
                width: 100%;
                display: inline-block;
                font-size: 28px; /*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height: 40px; /*px*/
                white-space:nowrap;
                overflow:hidden;
            }
        }
    }
}
</style>

